/**
 * Platform detection utilities
 * Detects whether the app is running as Tauri desktop or web browser
 */

/**
 * Check if running inside the CEF host shell (the local-desktop shell). The CEF
 * host installs a `window.cefQuery` JS↔native bridge (host/src/osr.h); its
 * presence is the canonical "am I in the CEF shell" signal. This is the only
 * local-desktop shell — the app no longer has a Tauri runtime.
 */
export function isCefShell(): boolean {
  return typeof window !== 'undefined' && typeof (window as { cefQuery?: unknown }).cefQuery === 'function';
}

/**
 * Check if running as a local-desktop shell (the CEF host).
 * This is the right gate for "do I have a local backend" vs. the web/sign-in
 * flow — the shell runs the headless core locally.
 */
export function isLocalShell(): boolean {
  return isCefShell();
}

/**
 * Check if running in web browser (not the CEF host shell).
 * The CEF host is a local desktop shell, so it is NOT web — this is what keeps
 * the sign-in / machine-selector flow off in the migrated app.
 */
export function isWeb(): boolean {
  return !isLocalShell();
}

/**
 * Check if the build target is web (set at build time)
 */
export function isWebBuild(): boolean {
  return import.meta.env.VITE_BUILD_TARGET === 'web';
}
